import { uiTheme as t } from 'Components/ui';
import styled from 'styled-components';

// Inset horizontal del grid: cuánto se meten las cards desde el borde. MyCourses.styled.tsx
// consume esta misma constante para que el título de sección arranque en el mismo borde
// que las cards, en vez de duplicar el valor y arriesgar que se desincronicen.
export const GRID_INSET = '1rem';

// Grid fluido: el card compartido no tiene ancho fijo (el legacy sí, 345px).
export const ListMyCourses = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(16.25rem, 1fr));
  gap: 1.5rem;
  width: 100%;
  padding: 1rem ${GRID_INSET};
`;

export const DueText = styled.span<{ urgent: boolean }>`
  color: ${({ urgent }) => (urgent ? t.color.danger : t.color.muted)};
  font-size: clamp(0.75rem, 1vw, 0.8125rem);
  line-height: 1.35;
`;
